import { Capacitor } from "@capacitor/core";
import { isNative } from "@/lib/isNativePlatform";
import { getNativeAppVersion } from "./nativeAppVersion";
import { setClientSignature, type ClientPlatform } from "./signature";

export function currentPlatform(): ClientPlatform {
  if (!isNative()) return "web";
  try {
    const platform = Capacitor.getPlatform();
    return platform === "ios" || platform === "android" ? platform : "web";
  } catch {
    return "web";
  }
}

/**
 * Appelé une fois au démarrage (main.tsx). La plateforme et le build sont
 * connus tout de suite ; la version native arrive après une lecture du plugin
 * et remplace alors celle du bundle. Ne jette jamais.
 */
export async function initClientSignature(): Promise<void> {
  setClientSignature({
    platform: currentPlatform(),
    version: typeof __APP_VERSION__ === "string" ? __APP_VERSION__ : "",
    buildId: typeof __BUILD_ID__ === "string" ? __BUILD_ID__ : "",
  });
  const nativeVersion = await getNativeAppVersion();
  if (nativeVersion) setClientSignature({ version: nativeVersion });
}
